import _ from 'lodash';
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';

import DirectusService from '@/core/directus/directus.service';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';
import LanguageCode from '@/locale/language-code';

@Component
export default class News extends Vue {
  @Inject('directusService') private directusService: () => DirectusService;

  public currentLanguage: LanguageCode = this.$store.getters.currentLanguage;
  public issuer = '';
  public newsContent = '';
  public newsBackgroundColor = '';

  @Watch('$route', { immediate: true, deep: true })
  public onRouteChange(route: any) {
    this.issuer = route.params.issuer;
    if (route.params.issuer) {
      this.getContentFromCMS();
    }
  }

  @Watch('$store.getters.currentLanguage', { immediate: true, deep: true })
  public onLanguageChange(language: any) {
    this.currentLanguage = language;
    if (this.issuer) {
      this.getContentFromCMS();
    }
  }

  public getContentFromCMS(): void {
    const filter = {
      code: {
        eq: this.issuer
      }
    };

    this.directusService()
      .getCollection<ApplicationCenterCMSModel>(
        ApplicationCenterCMSModel,
        'application_centers',
        ['translation.news', 'translation.news_background_color'],
        filter,
        this.currentLanguage
      )
      .then((result: ApplicationCenterCMSModel[]) => {
        this.newsContent = _.get(result[0], 'news', '');
        this.newsBackgroundColor = _.get(result[0], 'news_background_color', '');
      });
  }
}
